/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/indent */
import _ from 'lodash';
import { PriorAuthorizationDomain, PriorAuthorizationDomainDetails } from '../../interfaces/PriorAuthorizationDomain';
import { PriorAuthorizationRequest, PriorAuthorizationServiceDetails } from '../../interfaces/PriorAuthorizationRequest';

interface DataObfuscator {
  removeSensitiveDomainData(domainObj: PriorAuthorizationDomain): PriorAuthorizationDomain;
  removeSensitiveApiDtoData(apiDtoObject: PriorAuthorizationRequest): PriorAuthorizationRequest;
}

const dataObfuscator: DataObfuscator = {
  removeSensitiveDomainData: (domainObj: PriorAuthorizationDomain) => {
    const clonedDomainObj = _.cloneDeep(domainObj);
    clonedDomainObj.priorAuthorizationDomainHeader.memberDOB = 'REMOVED';
    clonedDomainObj.priorAuthorizationDomainHeader.memberFirstName = 'REMOVED';
    clonedDomainObj.priorAuthorizationDomainHeader.memberLastName = 'REMOVED';
    clonedDomainObj.priorAuthorizationDomainHeader.memberId = 'REMOVED';
    clonedDomainObj.priorAuthorizationDomainHeader.servicingProvider.taxId = 'REMOVED';

        clonedDomainObj.priorAuthorizationDomianDetails.forEach((serviceDetail: PriorAuthorizationDomainDetails) => {
            serviceDetail.requestingProvider.taxId = 'REMOVED';
        });
        return clonedDomainObj;
    },

    removeSensitiveApiDtoData: (dtoObj: PriorAuthorizationRequest) => {
        const clonedDtoObj = _.cloneDeep(dtoObj);
        clonedDtoObj.priorAuthorizationHeader.memberDOB = 'REMOVED';
        clonedDtoObj.priorAuthorizationHeader.memberFirstname = 'REMOVED';
        clonedDtoObj.priorAuthorizationHeader.memberLastName = 'REMOVED';
        clonedDtoObj.priorAuthorizationHeader.memberId = 'REMOVED';
        clonedDtoObj.priorAuthorizationHeader.servicingProvider.taxId = 'REMOVED';

        clonedDtoObj.priorAuthorizationBody.forEach((serviceDetail: PriorAuthorizationServiceDetails) => {
            serviceDetail.requestingProvider.taxId = 'REMOVED';
        });
        return clonedDtoObj;
    },
};

export default dataObfuscator;
